module.exports = __webpack_public_path__ + "static/media/bi_mascot_ddory_m.caae910c.png";